(function () {
  'use strict';

  function clean(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, 180);
  }

  function track(eventName, payload) {
    if (!eventName) return;

    var detail = Object.assign(
      {
        event: eventName,
        page_path: window.location.pathname,
        page_title: document.title,
      },
      payload || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('movataa:track', { detail: detail }));
  }

  function datasetPayload(element) {
    var payload = {};
    Object.keys(element.dataset || {}).forEach(function (key) {
      if (key.indexOf('movParam') !== 0) return;
      var paramName = key
        .replace('movParam', '')
        .replace(/^[A-Z]/, function (letter) {
          return letter.toLowerCase();
        })
        .replace(/[A-Z]/g, function (letter) {
          return '_' + letter.toLowerCase();
        });
      payload[paramName] = clean(element.dataset[key]);
    });
    return payload;
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-mov-event]');
    if (!target) return;
    var payload = datasetPayload(target);
    payload.link_text = clean(target.innerText || target.getAttribute('aria-label'));
    payload.link_url = clean(target.getAttribute('href'));
    track(target.dataset.movEvent, payload);
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-mov-quiz-input]')) return;
    track('quiz_answer_selected', {
      quiz_name: 'skin_routine_finder',
      question_name: clean(input.name),
      answer_value: clean(input.value),
    });
  });

  document.addEventListener('variant:add', function (event) {
    var form = event.detail && event.detail.formElement;
    var productForm = form && form.closest('product-form');
    track('cart_item_added', {
      source: 'product_form',
      product_title: clean(productForm && productForm.dataset.productTitle),
      product_handle: clean(productForm && productForm.dataset.productHandle),
      variant_id: clean(event.detail && event.detail.variant && event.detail.variant.id),
      quantity: event.detail && event.detail.quantity ? Number(event.detail.quantity) : 1,
    });
  });

  window.movataaTrack = track;
})();
